import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnProcessState } from './bpmn-process-state.selector';

const getSelectedTreatmentActivityId = (state: State): any => state.selectedTreatmentNodeId;

export const selectSelectedTreatmentActivityId: MemoizedSelector<object, string> =
  createSelector(selectBpmnProcessState, getSelectedTreatmentActivityId);
